import { DragDropModule } from '@angular/cdk/drag-drop';

import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ChoicesRatingFieldComponent } from '@shared/components/dynamic-form/components/choices-rating-field/choices-rating-field.component';
import { DropdownFieldComponent } from '@shared/components/dynamic-form/components/dropdown-field/dropdown-field.component';
import { DynamicChoicesFieldComponent } from '@shared/components/dynamic-form/components/dynamic-choices-field/dynamic-choices-field.component';
import { FreeTextFieldComponent } from '@shared/components/dynamic-form/components/free-text-field/free-text-field.component';
import { RichTextEditorFieldComponent } from '@shared/components/dynamic-form/components/rich-text-editor-field/rich-text-editor-field.component';
import { SectionSummaryFieldComponent } from '@shared/components/dynamic-form/components/section-summary-field/section-summary-field.component';
import { StarRatingFieldComponent } from '@shared/components/dynamic-form/components/star-rating-field/star-rating-field.component';
import { YesNoRatingFieldComponent } from '@shared/components/dynamic-form/components/yes-no-rating-field/yes-no-rating-field.component';
import { DynamicField } from '@shared/components/dynamic-form/models/field';
import { DynamicFormService } from '@shared/components/dynamic-form/services/dynamic-form.service';
import { FIELD_TYPE } from '@shared/constants/field-type.const';
@Component({
  selector: 'app-form-field',
  imports: [
    ReactiveFormsModule,
    DragDropModule,
    StarRatingFieldComponent,
    ChoicesRatingFieldComponent,
    DynamicChoicesFieldComponent,
    YesNoRatingFieldComponent,
    SectionSummaryFieldComponent,
    RichTextEditorFieldComponent,
    FreeTextFieldComponent,
    DropdownFieldComponent,
    TranslateModule,
  ],
  templateUrl: './form-field.component.html',
})
export class FormFieldComponent {
  field = input.required<DynamicField>();
  form = input.required<FormGroup>();
  inEditorMode = input<boolean>(false);
  errorsDisplayedOnSave = input<boolean>(false);
  formSubmitted = input<boolean>(false);

  dynamicFormService = inject(DynamicFormService);

  FieldType = FIELD_TYPE;

  get formControl() {
    return this.form().controls[this.field().key];
  }

  get errorMessageDisplayed(): boolean {
    const hasError = this.formControl.hasError('required');

    return (
      !this.inEditorMode() &&
      (this.errorsDisplayedOnSave()
        ? this.formSubmitted() && hasError
        : hasError)
    );
  }
}
